import { render, staticRenderFns } from "./PayrollConfig.vue?vue&type=template&id=3201e413&scoped=true&"
import script from "./PayrollConfig.vue?vue&type=script&lang=js&"
export * from "./PayrollConfig.vue?vue&type=script&lang=js&"
import style0 from "./PayrollConfig.vue?vue&type=style&index=0&id=3201e413&prod&scoped=true&lang=scss&"
import style1 from "./PayrollConfig.vue?vue&type=style&index=1&id=3201e413&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201e413",
  null
  
)

export default component.exports